import { type ButtonLink, Link, type TextLink } from 'braid-design-system';
import { type ReactNode, type MouseEvent, createElement } from 'react';

import { trackPageInteraction } from 'src/modules/AnalyticsTracker';

interface TrackingLinkProps {
  renderAs: typeof TextLink | typeof ButtonLink | typeof Link;
  href: string;
  'data-analytics'?: string;
  'data-analytics-origin': string;
  onClick?: any;
  children: ReactNode;
  [restProps: string]: any; // allow any other props to be accepted and propagated to the rendered components
}

const TrackingLink = (props: TrackingLinkProps) => {
  const { href, onClick, children, renderAs = Link, ...restProps } = props;

  const handleClick = (event: MouseEvent, ...params: any) => {
    const trackingEventName = props['data-analytics'];
    const trackingActionOrigin =
      props['data-analytics-origin'] || 'unknown action origin';

    if (href === '#') {
      event.preventDefault();
    }

    if (trackingEventName && trackingActionOrigin) {
      trackPageInteraction(trackingEventName, trackingActionOrigin);
    }

    if (typeof onClick === 'function') {
      onClick(event, ...params);
      return;
    }

    return;
  };

  if (!href) {
    return null;
  }

  const combinedProps = {
    onClick: handleClick,
    href,
    ...restProps,
  };

  return createElement(renderAs, combinedProps, children);
};

export default TrackingLink;
